module.exports = __webpack_public_path__ + "img/71.b3ab51b0.jpg";